class TrStepsCards extends HTMLElement {
  selectors = {
    list: '[data-tr-js-steps-cards-list]',
    item: '[data-tr-js-steps-card]',
  }

  attributes = {}

  stateClasses = {}

  connectedCallback() {
    this.listElement = this.querySelector(this.selectors.list)
    this.itemElements = this.querySelectorAll(this.selectors.item)
    this.resizeObserver = new ResizeObserver(this.updateHeight)

    this.init()
    this.bindEvents()
  }

  disconnectedCallback() {
    this.destroy()
  }

  init() {
    this.itemElements.forEach((itemElement) => {
      this.resizeObserver.observe(itemElement)
    })
    requestAnimationFrame(this.updateHeight)
  }

  bindEvents() {
    window.addEventListener('resize', this.updateHeight)
  }

  updateHeight = () => {
    if (!this.listElement || window.innerWidth <= 750) return

    const listHeight = [...this.itemElements].reduce(
      (currentHeight, itemElement) => {
        const cardElement = itemElement.firstElementChild
        const cardHeight = cardElement
          ? cardElement.offsetHeight
          : itemElement.offsetHeight

        return Math.max(
          currentHeight,
          itemElement.offsetTop + cardHeight
        )
      },
      0
    )

    this.listElement.style.setProperty(
      '--trCardsGridStepsHeight',
      `${Math.ceil(listHeight) + 1}px`
    )
  }

  destroy() {
    window.removeEventListener('resize', this.updateHeight)
    this.resizeObserver.disconnect()
  }
}

if (!customElements.get('tr-steps-cards')) {
  customElements.define('tr-steps-cards', TrStepsCards)
}